import React, { AriaAttributes } from 'react';
import classnames from 'classnames';

import s from './LegacyListMenu.scss';

export type ListMenuItem = {
  key: string;
  renderElement: (ListMenuItem) => React.ReactNode;
  className?: string;
  disabled?: boolean;
};

export interface Props {
  items: ListMenuItem[];
  className?: string;
  containerId?: string;
  containerRole?: string;
  itemRole?: string;
  'aria-labelledby'?: AriaAttributes['aria-labelledby'];
}

export const ListMenu: React.FC<Props> = ({
  items,
  className,
  containerId,
  containerRole,
  itemRole,
  'aria-labelledby': ariaLabelledBy,
}) => (
  <ul
    className={classnames(className, s['list'])}
    id={containerId}
    role={containerRole}
    aria-labelledby={ariaLabelledBy}
  >
    {items.map(
      item =>
        !item.disabled && (
          <li
            key={item.key}
            className={classnames(s['item'], item.className)}
            role={itemRole}
          >
            {item.renderElement(item)}
          </li>
        )
    )}
  </ul>
);

ListMenu.displayName = 'LegacyListMenu';

export default ListMenu;
